import {
  getPlayPath,
  getDesignPath,
  getDevelopmentPath,
  getTestingPath,
  getArchitecturePath,
} from '../../routing/route';

export const renderLandingView = (container: HTMLElement, onNavigate: (path: string) => void): void => {
  const playPath = getPlayPath();
  const designPath = getDesignPath();
  const developmentPath = getDevelopmentPath();
  const testingPath = getTestingPath();
  const architecturePath = getArchitecturePath();

  container.innerHTML = `
    <div class="landing-page">
      <header class="landing-header">
        <div class="landing-hero">
          <p class="landing-badge">Webブラウザ向け 2D対戦格闘ゲーム</p>
          <h1 class="landing-title">OFFICE CLASH</h1>
          <p class="landing-subtitle">- 定時なき戦い -</p>
          <p class="landing-lead">営業部 vs 開発部。深夜のオフィス頂上決戦。</p>
          <div class="landing-actions">
            <a href="${playPath}" class="landing-cta-button" data-nav="${playPath}">無料でプレイ</a>
          </div>
        </div>
      </header>

      <main class="landing-content">
        <section class="landing-section">
          <h2>ゲーム概要</h2>
          <p>
            「OFFICE CLASH - 定時なき戦い -」は、PC Webブラウザで動作する2D対戦格闘ゲームです。
            システム会社や一般企業の各部門（営業部・開発部）が戦う対戦格闘ゲームです。
          </p>
        </section>

        <section class="landing-section">
          <h2>ゲームモード</h2>
          <div class="landing-grid">
            <div class="landing-card">
              <h3>VS CPU</h3>
              <p>プレイヤーが営業部または開発部を選択し、もう一方のキャラクターを操作するCPUと対戦するモードです。</p>
            </div>
            <div class="landing-card">
              <h3>ローカル2人対戦</h3>
              <p>同一PC上でキーボードまたはゲームパッドを使用して2人で対戦を行うモードです。</p>
            </div>
          </div>
        </section>

        <section class="landing-section">
          <h2>プレイアブルキャラクター</h2>
          <div class="landing-grid">
            <div class="landing-card">
              <h3>営業部</h3>
              <p class="landing-card-type">近距離ラッシュ・高機動</p>
              <ul class="landing-move-list">
                <li><strong>通常技:</strong> 名刺ジャブ、クロージングストレート、飛び込み営業</li>
                <li><strong>必殺技:</strong> 二枚舌ラッシュ（3連撃）、無理な納期設定（突進・試合時間短縮効果）</li>
                <li><strong>超必殺技:</strong> 「できます！」（即答のコミット）</li>
              </ul>
            </div>
            <div class="landing-card">
              <h3>開発部</h3>
              <p class="landing-card-type">中距離・設置・カウンター型</p>
              <ul class="landing-move-list">
                <li><strong>通常技:</strong> キーボード殴打、要件定義書スイング、障害対応ドロップ</li>
                <li><strong>必殺技:</strong> 仕様変更カウンター（当身）、スパゲッティコード（設置罠・SLOW減速効果）</li>
                <li><strong>超必殺技:</strong> 深夜3時の強制ロールバック</li>
              </ul>
            </div>
          </div>
        </section>

        <section class="landing-section">
          <h2>バトルシステム</h2>
          <div class="landing-grid">
            <div class="landing-card">
              <h3>Guard（ガード）</h3>
              <p>相手の攻撃を防ぎダメージを軽減します（一部技に削りダメージあり）。</p>
            </div>
            <div class="landing-card">
              <h3>Counter（当身カウンター）</h3>
              <p>相手の攻撃を受け止めて成立する専用の迎撃反撃システムです。</p>
            </div>
            <div class="landing-card">
              <h3>Skill（必殺技）</h3>
              <p>各部門の特性に応じた固有技（時間減算、罠設置など）を使用できます。</p>
            </div>
            <div class="landing-card">
              <h3>Trap & SLOW</h3>
              <p>設置物に触れた相手の移動速度を一定時間低下させます。</p>
            </div>
            <div class="landing-card">
              <h3>TIME_PENALTY</h3>
              <p>技の命中に応じて試合残り時間を直接減算するシステムです。</p>
            </div>
            <div class="landing-card">
              <h3>K.O.</h3>
              <p>相手のHPを0にすることでラウンド勝利となります。</p>
            </div>
          </div>
        </section>

        <section class="landing-section">
          <h2>開発・技術情報</h2>
          <p>OFFICE CLASHの設計、開発工程、自動テスト戦略、およびWeb配信アーキテクチャに関する技術資料です。</p>
          <div class="landing-grid">
            <a href="${designPath}" class="landing-card landing-article-card" data-nav="${designPath}">
              <span class="landing-card-badge">Design</span>
              <h3>ゲームデザイン</h3>
              <p>2キャラクターの戦闘特性と棒人間ビジュアル（Minimal Readable Presentation）の設計方針。</p>
            </a>
            <a href="${developmentPath}" class="landing-card landing-article-card" data-nav="${developmentPath}">
              <span class="landing-card-badge">Development</span>
              <h3>開発工程</h3>
              <p>Phase 0からの技術検証タイムラインとPure TypeScriptによる戦闘Coreの実装履歴。</p>
            </a>
            <a href="${testingPath}" class="landing-card landing-article-card" data-nav="${testingPath}">
              <span class="landing-card-badge">Testing</span>
              <h3>テスト戦略</h3>
              <p>Vitest決定論的シミュレーション、Playwright E2E、Visual Regression等の多層自動テスト。</p>
            </a>
            <a href="${architecturePath}" class="landing-card landing-article-card" data-nav="${architecturePath}">
              <span class="landing-card-badge">Architecture</span>
              <h3>アーキテクチャ</h3>
              <p>Core/Presentation分離、単一index.html + SPA Fallback、Cloudflare Pages配信基盤の設計。</p>
            </a>
          </div>
        </section>

        <section class="landing-section landing-cta-section">
          <h2>今すぐ対戦を始める</h2>
          <div class="landing-actions">
            <a href="${playPath}" class="landing-cta-button" data-nav="${playPath}">無料でプレイ</a>
          </div>
        </section>
      </main>

      <footer class="landing-footer">
        <p>&copy; 2026 promptlab-games.com / デジガーデン</p>
      </footer>
    </div>
  `;

  // Attach navigation listeners to SPA internal links
  const links = container.querySelectorAll<HTMLAnchorElement>('a[data-nav]');
  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const targetPath = link.getAttribute('data-nav') ?? playPath;
      onNavigate(targetPath);
    });
  });
};
